import React from 'react'
import HeroSection from '../components/Home/HeroSection'
import Product from '../components/Home/Product'
import HomeAbout from '../components/Home/HomeAbout'
import Features from '../components/Home/Features'
import Adventure from '../components/Home/Adventure'
import Imageslider from '../components/Home/Imageslider'
import Heroo from '../components/Home/Heroo'
import Form from '../components/Home/Form'
import Footer from '../components/Footer/Footer'


const Homepage = () => {
    return (
        <div>
        <HeroSection/>
        <Product/>
        <HomeAbout/>
        <Features/>
        <Adventure/>
        <Imageslider/>
   
        <Heroo/>
        <Form/>
        <Footer/>
      

        </div>
    )
}

export default Homepage